import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environment-configurations';
import { PetitionerService } from 'src/app/services/petitioner.service';

@Component({
  selector: 'app-internal-job-posting',
  templateUrl: './internal-job-posting.component.html',
  styleUrls: ['./internal-job-posting.component.scss']
})
export class InternalJobPostingComponent implements OnInit {
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = [];
  thisWeekdisplayedColumns: string[];
  lastWeekdisplayedColumns: string[];
  selectedTabIndex = 0;
  pageEvent: PageEvent;
  pageSizeOptions = [25,50,100]
  pageIndex:number = 1;//default
  pageSize:number = 25;//default
  todayRecordCount:number = 0;
  userId: string;
  companyId: any;
  fromDate:any
  toDate:any;
  userType: string;
  filterModalComponent: any;
  thisWeek: { startDate: string, endDate: string };
  lastWeek: { startDate: string, endDate: string };
  companyLogo: any;
  companyName: any;
  socJobTitle: any;
  socCode: any;
  location: any;
  addressLine1: any;
  addressLine2: any;
  city: any;
  state: any;
  postCode: any;
  country: any;
  startDate: any;
  endDate: any;
  totalCount: any;
  formattedCompLogo: string;
  isPostedDtlsModalOpen: boolean = false;
  isPostFilesModalOpen: boolean = false;
  modalData: any = {};
  docData = [];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  fileName: any;
  fileLocation: any;
  todayCount: number;
  thisWeekCount: number;
  lastWeekCount: number;
  constructor(
    private petitionerService: PetitionerService,
    private activatedRoute: ActivatedRoute,
  ) { 
    
  }
  todaysColumns = [
    { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
    { columnDef: 'socJobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
    { columnDef: 'socCode', header: 'SOC CODE', columnType: 'text', customClass: '' },
    { columnDef: 'location', header: 'Location', columnType: 'text', customClass: '' },
    { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
    { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
    { columnDef: 'noOfPositions', header: 'No.Positions', columnType: 'text', customClass: '' },
    { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
  ];
  thisWeekColumns = [
    { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
    { columnDef: 'socJobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
    { columnDef: 'socCode', header: 'SOC CODE', columnType: 'text', customClass: '' },
    { columnDef: 'location', header: 'Location', columnType: 'text', customClass: '' },
    { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
    { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
    { columnDef: 'noOfPositions', header: 'No.Positions', columnType: 'text', customClass: '' },
    { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
  ];
  lastWeekcolumns = [
    { columnDef: 'companyName', header: 'Company Name', columnType: 'text', customClass: '' },
    { columnDef: 'socJobTitle', header: 'SOC Job Title', columnType: 'text', customClass: '' },
    { columnDef: 'socCode', header: 'SOC CODE', columnType: 'text', customClass: '' },
    { columnDef: 'location', header: 'Location', columnType: 'text', customClass: '' },
    { columnDef: 'startDate', header: 'Start Date', columnType: 'text', customClass: '' },
    { columnDef: 'endDate', header: 'End Date', columnType: 'text', customClass: '' },
    { columnDef: 'noOfPositions', header: 'No.Positions', columnType: 'text', customClass: '' },
    { columnDef: 'action', header: 'Action', columnType: 'icon', customClass: '' }
  ];
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      this.companyId = this.activatedRoute.snapshot.params['companyId'];
    });
    this.loadLcaCodes(this.selectedTabIndex);
  }
  ngAfterContentInit() {
    this.displayedColumns = this.todaysColumns.map(c => c.columnDef);
    this.thisWeekdisplayedColumns = this.thisWeekColumns.map(c => c.columnDef);
    this.lastWeekdisplayedColumns = this.lastWeekcolumns.map(c => c.columnDef);
  }
  onTabChanged(event: any): void {
    console.log(event);
    this.selectedTabIndex = event.index;
    switch (this.selectedTabIndex) {
      case 0:
        this.loadLcaCodes(this.selectedTabIndex);
        break;
      case 1:
        this.loadLcaCodes(this.selectedTabIndex);
        break;
      case 2:
        this.loadLcaCodes(this.selectedTabIndex);
        break;
      default:
        break;
    }
  }
  loadLcaCodes(selectedTabIndex) {
    // Set today's date for both fromDate and toDate
    if (selectedTabIndex == 0) {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth() + 1; // Months are zero-based
      const day = today.getDate();
      this.fromDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      this.toDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
      let data: any = [];
      this.petitionerService.getJobPostDetails(this.companyId, this.fromDate, this.toDate).subscribe(result => {
        if (result && result.length > 0) {
          let payload;
          
        result.forEach((item, index) => {
          this.companyLogo= item.lcaApplication.company.companyLogo;
          this.formattedCompLogo = 'data:image/jpeg;base64,' + this.companyLogo,
          this.addressLine1=item?.lcaApplication?.company?.address[0]?.addressLine1;
          this.addressLine2= item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '';
          this.city = item?.lcaApplication?.company?.address[0]?.city;
          this.state =item?.lcaApplication?.company?.address[0]?.stateProvinceCode;
          this.postCode = item?.lcaApplication?.company?.address[0]?.postCode;
          this.country=item?.lcaApplication?.company?.address[0]?.countryCode?.countryName;
         
          payload={
          companyName :item.lcaApplication.company.companyName,
          socJobTitle : item.lcaApplication.socTitle,
          socCode : item.lcaApplication.socCode,
          addressLine1:item?.lcaApplication?.company?.address[0]?.addressLine1,
          addressLine2: item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '',
          city : item?.lcaApplication?.company?.address[0]?.city,
          state :item?.lcaApplication?.company?.address[0]?.stateProvinceCode,
          postCode : item?.lcaApplication?.company?.address[0]?.postCode,
          country:item?.lcaApplication?.company?.address[0]?.countryCode?.countryName,
          location : this.addressLine1 + ', ' + this.addressLine2 ? this.addressLine2 + ', ' : '' + this.city + ', ' + this.state + ', ' + this.postCode + ', ' + this.country,
          startDate: item?.lcaApplication?.employmentStartDate,
          endDate:item?.lcaApplication?.employmentEndDate,
          noOfPositions: item?.lcaApplication?.newEmploymentCount,
          lcaId: item?.lcaApplication?.id,
          caseNumber: item?.lcaApplication?.caseNumber,
          postedDate: item?.postedDate,
          documents: item?.documents
         
              }
            data.push(payload);
          });
        }
        if(data[0].lcaId) {
          this.dataSource = new MatTableDataSource(data);
        } else {
          this.dataSource = new MatTableDataSource([]);
        }
        this.todayCount = this.dataSource.data.length;
      });
    }
    if (selectedTabIndex == 1) {
      this.getThisWeekDates();
      let data: any = [];
      this.petitionerService.getJobPostDetails(this.companyId, this.thisWeek.startDate, this.thisWeek.endDate).subscribe(result => {
        if (result && result.length > 0) {
          let payload;
          
        result.forEach((item, index) => {
          this.companyLogo= item.lcaApplication.company.companyLogo;
          this.formattedCompLogo = 'data:image/jpeg;base64,' + this.companyLogo,
          this.addressLine1=item?.lcaApplication?.company?.address[0]?.addressLine1;
          this.addressLine2= item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '';
          this.city = item?.lcaApplication?.company?.address[0]?.city;
          this.state =item?.lcaApplication?.company?.address[0]?.stateProvinceCode;
          this.postCode = item?.lcaApplication?.company?.address[0]?.postCode;
          this.country=item?.lcaApplication?.company?.address[0]?.countryCode?.countryName;
          payload={
          companyName :item.lcaApplication.company.companyName,
          socJobTitle : item.lcaApplication.socTitle,
          socCode : item.lcaApplication.socCode,
          addressLine1:item?.lcaApplication?.company?.address[0]?.addressLine1,
          addressLine2: item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '',
          city : item?.lcaApplication?.company?.address[0]?.city,
          state :item?.lcaApplication?.company?.address[0]?.stateProvinceCode,
          postCode : item?.lcaApplication?.company?.address[0]?.postCode,
          country:item?.lcaApplication?.company?.address[0]?.countryCode?.countryName,
          location : this.addressLine1 + ', ' + (this.addressLine2 ? this.addressLine2 + ', ' : '') + this.city + ', ' + this.state + ', ' + this.postCode + ', ' + this.country,
          startDate: item?.lcaApplication?.employmentStartDate,
          endDate:item?.lcaApplication?.employmentEndDate,
          noOfPositions: item?.lcaApplication?.newEmploymentCount,
          lcaId: item?.lcaApplication?.id,
          caseNumber: item?.lcaApplication?.caseNumber,
          postedDate: item?.postedDate,
          documents: item?.documents
              }
            data.push(payload);
          });
        }
        if(data[0].lcaId) {
          this.dataSource = new MatTableDataSource(data);
        } else {
          this.dataSource = new MatTableDataSource([]);
        }
        this.thisWeekCount = this.dataSource.data.length;
      });
    } else if (selectedTabIndex == 2) {
      this.getLastWeekDates();
      let data: any = [];
      this.petitionerService.getJobPostDetails(this.companyId, this.lastWeek.startDate, this.lastWeek.endDate).subscribe(result => {
        if (result && result.length > 0) {
          let payload;
          
        result.forEach((item, index) => {
          this.companyLogo= item.lcaApplication.company.companyLogo;
          this.formattedCompLogo = 'data:image/jpeg;base64,' + this.companyLogo,
          this.addressLine1=item?.lcaApplication?.company?.address[0]?.addressLine1;
          this.addressLine2= item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '';
          this.city = item?.lcaApplication?.company?.address[0]?.city;
          this.state =item?.lcaApplication?.company?.address[0]?.stateProvinceCode;
          this.postCode = item?.lcaApplication?.company?.address[0]?.postCode;
          this.country=item?.lcaApplication?.company?.address[0]?.countryCode?.countryName;
          payload={
          companyName :item.lcaApplication.company.companyName,
          socJobTitle : item.lcaApplication.socTitle,
          socCode : item.lcaApplication.socCode,
          addressLine1:item?.lcaApplication?.company?.address[0]?.addressLine1,
          addressLine2: item?.lcaApplication?.company?.address[0]?.addressLine2 ? item?.lcaApplication?.company?.address[0]?.addressLine2 : '',
          city : item?.lcaApplication?.company?.address[0]?.city,
          state :item?.lcaApplication?.company?.address[0]?.stateProvinceCode,
          postCode : item?.lcaApplication?.company?.address[0]?.postCode,
          country:item?.lcaApplication?.company?.address[0]?.countryCode?.countryName,
          location : this.addressLine1 + ', ' + this.addressLine2 ? this.addressLine2 + ', ' : '' + this.city + ', ' + this.state + ', ' + this.postCode + ', ' + this.country,
          startDate: item?.lcaApplication?.employmentStartDate,
          endDate:item?.lcaApplication?.employmentEndDate,
          noOfPositions: item?.lcaApplication?.newEmploymentCount,
          lcaId: item?.lcaApplication?.id,
          caseNumber: item?.lcaApplication?.caseNumber,
          postedDate: item?.postedDate,
          documents: item?.documents
              }
            data.push(payload);
          });
        }
        if(data[0].lcaId) {
          this.dataSource = new MatTableDataSource(data);
        } else {
          this.dataSource = new MatTableDataSource([]);
        }
        this.lastWeekCount = this.dataSource.data.length;
      });
    }
  }
  paginationEvent(event:PageEvent){
    this.pageIndex =  event.pageIndex+1;
    this.pageSize = event.pageSize;
    this.loadLcaCodes(this.selectedTabIndex) //API call
   }

   ngAfterViewInit() {
    if (this.dataSource && this.dataSource.paginator) {
      this.dataSource.paginator = this.paginator;
    }
   
  }
   getThisWeekDates() {
    const today = new Date();
    const currentDay = today.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
    const diff = today.getDate() - currentDay + (currentDay === 0 ? -6 : 1); // Adjust to Monday if the current day is Sunday
    const startDate = new Date(today.setDate(diff));
  
    // The endDate is 6 days after the startDate (end of the week)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
  
    // Format the dates as strings in "YYYY-MM-DD" format
    const formattedStartDate = this.formatDate(startDate);
    const formattedEndDate = this.formatDate(endDate);
  
    // Assign the dates to the thisWeek variable
    this.thisWeek = { startDate: formattedStartDate, endDate: formattedEndDate };
  
    console.log("This Week:", this.thisWeek);
  }

  getLastWeekDates() {
    const today = new Date();
    const currentDay = today.getDay(); // 0 for Sunday, 1 for Monday, ..., 6 for Saturday
    const diff = today.getDate() - currentDay - 7; // Subtract 7 days to get the start of the last week
    const startDate = new Date(today.setDate(diff));
  
    // The endDate is 6 days after the startDate (end of the last week)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
  
    // Format the dates as strings in "YYYY-MM-DD" format
    const formattedStartDate = this.formatDate(startDate);
    const formattedEndDate = this.formatDate(endDate);
  
    // Assign the dates to the lastWeek variable
    this.lastWeek = { startDate: formattedStartDate, endDate: formattedEndDate };
  }
  
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  openModal(item: any) {
    this.modalData = {
      lcaId: item.caseNumber,
      postedDate: item.postedDate,
      petitioner: item.companyName,
      location: item.location,
      numPositions: item.noOfPositions,
    };
  
    this.isPostedDtlsModalOpen = true;
  }

  closeModal() {
    this.isPostedDtlsModalOpen = false;
  }

  openFilesModal(item: any) {
   this.docData = [];
    var docPayload;
    item?.documents.forEach((docItem, index) => {
      docPayload={
      fileName: docItem.fileCategory?.name,
      fileLocation: docItem.fileLocation
      }
      this.docData.push(docPayload);
    });
  
    this.isPostFilesModalOpen = true;
  }

  closeFilesModal() {
    this.isPostFilesModalOpen = false;
  }
  
  openDoc(doc){
    const docPath = doc.fileLocation.substring(23);
    window.open(`${environment.docs}${docPath}`, "_blank");
  }
   
}
